import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/performanceCheck'; // Initialize performance monitoring

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const mount = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

// public/index.html prerenders the header and hero. Let that static HTML reach
// the screen, and let the browser record it as the Largest Contentful Paint,
// before React replaces it. Without this wait, React can swap the nodes out
// before Chrome reports the static paint, and LCP waits for the app instead.
let mounted = false;
const mountOnce = () => {
  if (mounted) return;
  mounted = true;
  mount();
};
const afterPaint = (fn: () => void) =>
  window.requestAnimationFrame(() => window.requestAnimationFrame(() => window.setTimeout(fn, 0)));

// Only the home page ships the prerendered hero; every other route mounts now.
const hasPrerenderedHero = Boolean(document.querySelector('#root .hero'));

if (!hasPrerenderedHero || typeof window.requestAnimationFrame !== 'function') {
  mountOnce();
} else if (
  typeof PerformanceObserver !== 'undefined' &&
  (PerformanceObserver.supportedEntryTypes || []).includes('largest-contentful-paint')
) {
  const observer = new PerformanceObserver(() => {
    observer.disconnect();
    afterPaint(mountOnce);
  });
  observer.observe({ type: 'largest-contentful-paint', buffered: true });
  // Never hold the app back for long if no entry arrives.
  window.setTimeout(() => {
    observer.disconnect();
    mountOnce();
  }, 300);
} else {
  afterPaint(mountOnce);
  // Animation frames pause in background tabs; never wait on them for long.
  window.setTimeout(mountOnce, 300);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
